export default function filterNumbers(keyEvent) {
    // regex pattern
    const regex = new RegExp('^[0-9]*$');

    // replace persian , arabic to eng number
    const val = keyEvent.key
        .replace(/[\u0660-\u0669]/g, function(c) {
            return c.charCodeAt(0) - 0x0660;
        })
        .replace(/[\u06f0-\u06f9]/g, function(c) {
            return c.charCodeAt(0) - 0x06f0;
        });

    // check if value in number let change input value
    if (!regex.test(val)) return keyEvent.preventDefault();
    return true;
}

